module.exports = __webpack_public_path__ + "static/media/Baik.4274a0ad.jpg";